import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/daisy';
import { CourseFormVariant } from './CourseForm';

type FormControlsProps = {
  variant: CourseFormVariant;
  isLoading?: boolean;
  onCancel?: () => void;
  hasChanges?: boolean;
};

export default function FormControls({
  variant = 'default',
  isLoading,
  onCancel,
  hasChanges,
}: FormControlsProps) {
  if (variant === 'inline')
    return <FormControlsInline isLoading={isLoading} onCancel={onCancel} />;
  return <FormControlsDefault isLoading={isLoading} hasChanges={hasChanges} />;
}

const FormControlsInline = ({
  isLoading,
  onCancel,
}: Pick<FormControlsProps, 'isLoading' | 'onCancel'>) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.courseForm.form',
  });

  return (
    <div className="flex justify-end gap-2">
      <Button
        type="button"
        className="grow bg-base-300"
        onClick={onCancel}
        disabled={isLoading}
      >
        {t('cancel')}
      </Button>
      <Button
        type="submit"
        color="secondary"
        className="grow"
        disabled={isLoading}
        loading={isLoading}
      >
        {t('save')}
      </Button>
    </div>
  );
};

const FormControlsDefault = ({
  isLoading,
  hasChanges,
}: Pick<FormControlsProps, 'isLoading' | 'hasChanges'>) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.courseForm.form',
  });
  return (
    <div className="flex justify-end">
      <Button
        type="submit"
        color="primary"
        className="px-16"
        disabled={isLoading || !hasChanges}
        loading={isLoading}
      >
        {t('save')}
      </Button>
    </div>
  );
};
